// Shared constants and helpers for the RigDetailEditor and its sub-components.

export const inputCls = 'bg-[#111115] border-white/10 text-white h-11 placeholder:text-white/20 focus:border-primary/60';
export const labelCls = 'text-white/40 text-[10px] font-bold tracking-widest mb-1.5 block';

export const slugify = (s) => s.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');

// Normalise a stored gallery entry (legacy string or new object) into a shared-library photo.
// Preserves the stored content `hash` so ImageDropZone can detect duplicate re-uploads
// against photos that were saved in a previous session.
export const normPhoto = (p) => {
  if (!p) return null;
  if (typeof p === 'string') return { url: p, hash: '', show_booking: true, show_showcase: true };
  return {
    url: p.url || '',
    hash: p.hash || '',
    show_booking: p.show_booking !== false,
    show_showcase: p.show_showcase !== false,
  };
};
export const normList = (arr) => (arr || []).map(normPhoto).filter((p) => p && p.url);

export const CATEGORIES = [
  { key: 'gt', label: 'GT' },
  { key: 'formula', label: 'Formula' },
  { key: 'rally', label: 'Rally' },
  { key: 'drift', label: 'Drift' },
  { key: 'other', label: 'Other' },
];

export const RATINGS = [
  { key: 'overall_rating', label: 'Overall' },
  { key: 'rating_realism', label: 'Realism' },
  { key: 'rating_immersion', label: 'Immersion' },
  { key: 'rating_hardware', label: 'Hardware' },
  { key: 'rating_comfort', label: 'Comfort' },
  { key: 'rating_beginner_friendly', label: 'Beginner' },
  { key: 'rating_competitive', label: 'Competitive' },
];

export const SPECS = [
  { key: 'spec_cockpit', label: 'Cockpit' },
  { key: 'spec_seat', label: 'Seat' },
  { key: 'spec_wheelbase', label: 'Wheelbase' },
  { key: 'spec_pedals', label: 'Pedals' },
  { key: 'spec_steering_wheel', label: 'Steering Wheel' },
  { key: 'spec_dashboard', label: 'Dashboard' },
  { key: 'spec_displays', label: 'Displays' },
  { key: 'spec_pc', label: 'PC Spec' },
  { key: 'spec_audio', label: 'Audio' },
];

export const EMPTY_SHOWCASE = {
  category: 'gt', short_description: '', full_description: '',
  hero_image_url: '', hero_video_url: '', gallery_images: [], showcase_video_url: '',
  overall_rating: 0, rating_realism: 0, rating_immersion: 0, rating_hardware: 0,
  rating_comfort: 0, rating_beginner_friendly: 0, rating_competitive: 0,
  experience_text: '', spec_cockpit: '', spec_seat: '', spec_wheelbase: '', spec_pedals: '',
  spec_steering_wheel: '', spec_dashboard: '', spec_displays: '', spec_pc: '', spec_audio: '',
  supported_games: [], booking_url: '', featured: false, sort_order: 0,
};